<template>
	<div class="storageoutprint" id="storageoutprint" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-form>
			<el-card>
				<el-row class="formTitle">
					<el-col :span="5" style="color:transparent">1</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="is.logistic" :true-label="1" :false-label="0" @change="ChangeLogisticCkb"></el-checkbox>
							<span>生成物流</span>
						</label>
					</el-col>
					<el-col :span="3">
						<label for>
							<el-checkbox v-model="sendremind" :true-label="1" :false-label="0"></el-checkbox>
							<span>发送提醒</span>
						</label>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="4" style="color:transparent">1</el-col>
					<el-col :span="14">
						<table style="width:99%">
							<tr>
								<td valign="top">
									<div class="formContent">
										<table class="htmltable" style="margin-left:70px">
											<tr class="b_font">
												<td class="tdleft">
													<span><b>批 次 号</b></span>
												</td>
												<td colspan="3">
													<el-input
														ref="handlebatch"
														@keyup.enter.native="EnterEvent('handlebatch')"
														@blur="updatebatch"
														v-model="form.handbatch"
													></el-input>
												</td>
											</tr>
											<tr>
												<td class="tdleft_bold">
													<span>
														<b>单  号</b>
													</span>
												</td>
												<td colspan="3" class="b_font">
													<el-input
														v-model="form.pkval"
														ref="pkval"
														@keyup.enter.native="EnterEvent('pkval')"
													></el-input>
												</td>
											</tr>
											<tr class="b_font">
												<td class="tdleft">
													<span><b>备  注</b></span>
												</td>
												<td colspan="3">
													<el-input
														ref="handlebatch"
														@keyup.enter.native="EnterEvent('handlebatch')"
														v-model="form.p_remark"
													></el-input>
												</td>
											</tr>
											<tr v-if="is.logistic == 1">
												<td class="tdleft"><span>操作时间</span></td>
												<td colspan="3" style="text-align:left;">
													<el-date-picker v-model="form.wltime" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
												</td>
											</tr>
											<tr v-if="is.logistic == 1">
												<td class="tdleft"><span>操作描述</span></td>
												<td colspan="3"><el-input ref="wlcontent" v-model="form.wlcontent"></el-input></td>
											</tr>
										</table>
									</div>
								</td>
							</tr>
							<tr>
								<td style="width:50%;">
									<div class="b_font" style="font-size:25pt;color:#ab4a32;padding-left:80px">
										<span v-if="form.perpkval != ''"><b>上一单 : {{ form.perpkval }}</b></span>
									</div>
									<div class="formCargo">
										<i class="el-icon-d-arrow-right"></i>
										<label>
											已扫描
											<span class="ordercount">{{ scanordercount }}</span>
											单
										</label>
									</div>
									<tableui
										style="width:99%;"
										ref="storageinout"
										:tableData="orderTable"
										:columns="scanordercolumns"
										@gridhandle="gridhandle"
										:gridheight="orderheight"
									></tableui>
								</td>
							</tr>
						</table>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			batch: '', //当前操作界面生成的临时批次号,可用于收费(暂时无用)
			fun: '问题件',
			scanordercount: 0,
			errormsg: '',
			currentstate: '', //当前操作状态
			errorfocus: false,
			windowHeight: (window.innerHeight * 88) / 100,
			orderheight: (window.innerHeight * 35) / 100 + 'px',
			errorwin: false,
			orderTable: [],
			is: {
				logistic: 0, //生成物流
			},
			form: {
				handlepkval: '', //实际操作的订单号
				pkval: '',
				handbatch: '',
				p_mode: '',
				perpkval: '',
				wlcontent: '',
				wltime: '',
				vipaccount: '',
				orderinfo: [],
				p_remark: '' //备注
			},
			pkvals: '', //如果扫描的是国内快递单号的话，有可能是多个订单号
			scanordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '100', sortable: false },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '80',
					sortable: false,
					template: [{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'removecheck' }]
				}
			],
			userid: localStorage.getItem('userid'),
			u_name: localStorage.getItem('u_name'),
			u_account: localStorage.getItem('u_account'),
			u_company: localStorage.getItem('u_company'),
			divclass: 'storageoutprint',
			isstop: 1,
			tempres: '',
			errorbatch: '', //问题件批次
			wlset: {},
			sendremind:0
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/storageprint.scss');
		});
		if(this.urlparam!=undefined){
			if(this.urlparam.batch!=undefined){
				this.form.handbatch=this.urlparam.batch;
			}
			if(this.urlparam.pkval!=undefined){
				this.form.pkval=this.urlparam.pkval;
			}
		}
		this.LoadWtjPage();
	},
	methods: {
		//获取勾选参数
		LoadWtjPage() {
			var that = this;
			var paraminfo = {
				userid: localStorage.getItem('userid')
			};
			this.$apipost.get.LoadWtjPage({ paraminfo: paraminfo }).then(res => {
				if (res != '') {
					that.is = res.userparam[0];
					if(that.form.handbatch=='')
						that.form.handbatch = res.handbatch;
					if (res.wlset != undefined) {
						that.wlset = res.wlset;
						if (res.wlset.w_context != undefined) {
							that.form.wlcontent = res.wlset.w_context;
						}
					}
					this.$nextTick(function() {
						if (that.form.handbatch == '') that.$refs.handlebatch.focus();
						else {
							if (that.$refs.pkval.length > 0) that.$refs.pkval[0].focus();
							else that.$refs.pkval.focus();
						}
					});
					that.GetOrderlist();
				}
			});
		},
		//列表操作栏事件
		gridhandle(e) {
			if (e.event == 'removecheck') {
				this.RollbackStorage(this.orderTable[e.index].p_pkval, parseInt(e.index));
			}
		},
		//文本框回调事件
		EnterEvent(control) {
			this.currentstate = control;
			if (control == 'pkval') {
				//获取订单信息
				this.form.pkval = this.form.pkval.trim();
				this.ScanPkVal(this.currentstate);
			}
			if (control == 'handlebatch') {
				if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
				else this.$refs.pkval.focus();
			}
		},
		//扫描单号触发事件
		ScanPkVal(type) {
			var isgo = true;
			if (this.form.handbatch == '') {
				this.$tool.message('请输入批次号', 2);
				this.ReadMsg('请输入批次号');
				isgo = false;
			}
			if (type == 'pkval') {
				if (this.form.pkval == '') isgo = false;
			}
			if (isgo) {
				this.StorageInOutHandle(1, 0);
			} else {
				this.form.pkval = '';
			}
		},
		//出入库操作 1-获取订单详情 2-计算费用 3-出入库操作
		StorageInOutHandle(handletype, index) {
			var that = this;
			var isgo = true;
			if (handletype != 1) {
				//这个判断是防止用户手动输入单号未回车，直接鼠标切换到其他输入框的情况
				if (that.form.handlepkval == '' || that.form.handlepkval == undefined) {
					if (that.$refs.pkval[0] != undefined) that.$refs.pkval[0].focus();
					else that.$refs.pkval.focus();

					isgo = false;
				}
			}
			if (isgo) {
				var pkvallist = [this.form.pkval];
				if (handletype == 3) {
					pkvallist = that.pkvals.split('★');
				}
				//debugger
				if (pkvallist.length - 1 >= index) {
					this.$tool.loading('正在操作', this.divclass);
					if (handletype == 3) this.form.handlepkval = pkvallist[index];
					var paraminfo = {
						handletype: handletype,
						pageparam: this._data
					};
					this.$apipost.post
						.HandleWtjPage({
							paraminfo: paraminfo
						})
						.then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if (handletype == 1)
									//获取订单信息
									that.HandleOrderInfo(res);
								else if (handletype == 3) that.HandleInOut(res, index, pkvallist);
							} else {
								this.ReadMsg('系统异常，请重试');
								index = pkvallist.length + 1;
								that.StorageInOutHandle(handletype, index);
							}
						});
				} else {
					if (pkvallist.length == index) {
						 if(this.is.logistic==1)
							 that.CreateStep();
						 if(this.sendremind==1)
							that.$tool.SendMessage(
							{msgid:'284-1',info:that._data,pkval:that.form.pkval,type:'4-q',showerror:false},that);
						//订单添加到已扫描表中
						that.addOrderList();
						//清空值，准备扫下一个单
						that.ClearInput();
					}
				}
			}
		},
		//生成物流
		CreateStep(){
			this.$apipost.post
				.CreateStep({
					pkval: this.form.pkval,
					batch:'',
					fun:this.fun,
					context:this.form.wlcontent,
					createtime:this.$tool.formatdate(this.form.wltime)
				})
				.then(res => {
					
				});
		},
		//处理订单信息
		HandleOrderInfo(res) {
			//debugger
			var that = this;
				that.pkvals = '';
				if(res.state=='0'){
					this.ReadMsg(res.message);
					if(res.message.indexOf('重复')>-1){
						that.form.pkval='';
						return false;
					}
				}
				that.form.handlepkval=this.form.pkval;
				that.pkvals=this.form.pkval + '★';
				// if (res.orderinfo.length > 0) {
				// 	that.form.handlepkval = res.orderinfo[0].p_pkval;
				// 	that.form.orderinfo = res.orderinfo[0];
				// 	that.errormsg = res.message;
				// 	res.orderinfo.forEach(e => {
				// 		that.pkvals += e.p_pkval + '★';
				// 	});
				// } else {
				// 	that.errormsg = res.message;
				// 	that.pkvals = this.form.pkval + '★';
				// 	that.form.handlepkval = this.form.pkval;
				// }
				if (that.pkvals != '') {
					that.pkvals = that.pkvals.substring(0, that.pkvals.length - 1);
				}
				if (that.is.logistic == 1) {
					if (that.form.wltime == '') {
						this.ReadMsg('请输入操作时间');
						return false;
					}
					if (that.form.wlcontent == '') {
						if (that.$refs.wlcontent[0] != undefined) that.$refs.wlcontent[0].focus();
						else that.$refs.wlcontent.focus();
						this.ReadMsg('请输入操作描述');
						return false;
					}
			}
			that.StorageInOutHandle(3, 0); //调用保存揽收
		},
		//处理出入库结果
		HandleInOut(res, index, pkvallist) {
			var that = this;
			if (res.state != undefined) {
				if (res.state == '1') {
					index = index + 1;
					if(that.errormsg=='')
						this.ReadMsg('成功');
					that.StorageInOutHandle(3, index);
				} else {
					that.errormsg = res.message;
					this.ReadMsg(res.message);
					index = pkvallist.length + 1;
					that.StorageInOutHandle(3, index);
				}
			} else {
				if (res.indexOf('LODOP') > -1) {
					eval(res);
					index = index + 1;
					that.StorageInOutHandle(3, index);
				} else {
					this.ReadMsg(res.message);
					index = pkvallist.length + 1;
					that.StorageInOutHandle(3, index);
				}
			}
		},
		//添加
		addOrderList() {
			if(this.errormsg.indexOf('重复')>0)
				return false;
			else{
				var orderinfo = [];
				orderinfo = [{p_pkval: this.form.pkval}];
				this.form.perpkval=this.form.pkval;
				if (this.orderTable.length == 0) this.orderTable = orderinfo;
				else {
					this.orderTable.splice(0, 0, orderinfo[0]);
				}
			}
		},
		//清空文本框
		ClearInput() {
			//debugger
			this.ScanSum();
			this.form.perpkval = this.form.pkval;
			this.form.pkval = '';
			this.errorbatch = '';
			this.errormsg='';
			
			if (this.$refs.pkval[0] != undefined) this.$refs.pkval[0].focus();
			else this.$refs.pkval.focus();
		},
		ScanSum() {
			//计算汇总
			this.scanordercount = this.orderTable.length;
		},
		//回滚
		RollbackStorage(p_pkval, orderindex) {
			var that = this;
			var paraminfo = { p_pkval: p_pkval };
			this.$apipost.post.DelStorageOrder({isin:'2',pkval:p_pkval,batch: ''}).then(res => {
				if (res.state == '1') {
					this.$tool.message('删除成功', 1);
					that.orderTable.splice(orderindex, 1);
					that.ScanSum();
				} else {
					this.$tool.message('删除失败', 0);
				}
			});
		},
		ChangeLogisticCkb(value) {
			if (value) {
				this.form.wltime = this.$tool.formatdate();
			} else {
				this.form.wltime = '';
			}
		},
		//更新出入库批次号
		updatebatch() {
			var newbatch = this.form.handbatch;
			if (newbatch != '') {
				var that = this;
				var paraminfo = { handbatch: this.form.handbatch, fun:this.fun, userid: localStorage.getItem('userid') };
				this.$apipost.post
					.UpdateOutBatch({
						paraminfo: paraminfo
					})
					.then(res => {
						that.GetOrderlist();
					});
			}
		},
		//根据批次号获取所有已扫描订单
		GetOrderlist() {
			var that = this;
			this.$apipost.get
				.GetWtjlistByBatch({
					handbatch: this.form.handbatch
				})
				.then(res => {
					that.orderTable = res.list;
					that.ScanSum();
				});
		},
		ReadMsg(msg) {
			if (this.$tool.checkprintcontrol()) {
				LODOP.FORMAT('VOICE:3;100', msg);
			}
		}
	}
};
</script>
